export default "/images/c4a882e15d214c9849b4f7f956f807b1.avif";